import React from 'react';
import { Button, Input } from '../../components/common';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useForm } from 'react-hook-form';
import { routes } from '../../lib/routes';
import { MdEast } from 'react-icons/md';

interface ForgetPasswordFormData {
  email: string;
}

const ForgetPasswordForm = () => {
  const { forgetPassword, error, isLoading } = useAuth();
  const {
    register,
    watch,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<ForgetPasswordFormData>();

  const disabledSubmit = watch('email') === '';

  const onSubmit = async (data: ForgetPasswordFormData) => {
    try {
      const response = await forgetPassword(data);
      if (response?.code !== 200) {
        setError('email', { message: response?.message as string });
        return;
      }
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <form className='w-full' onSubmit={handleSubmit(onSubmit)}>
      {error && (
        <div className='rounded-md bg-red-50 p-4 mb-3'>
          <div className='text-sm text-red-700'>{error}</div>
        </div>
      )}
      <div className='mb-6'>
        <Input
          label='Email ID'
          type='email'
          autoComplete='email'
          placeholder='Enter email ID'
          required
          helperText={errors.email?.message as string}
          color={errors.email?.message ? 'error' : 'default'}
          {...register('email', {
            required: 'Email is required',
            pattern: {
              value: /\S+@\S+\.\S+/,
              message: 'Please enter a valid email',
            },
          })}
        />
      </div>
      <Button
        type='submit'
        isLoading={isLoading}
        disabled={disabledSubmit}
        className='group relative w-full'
      >
        Reset Password <MdEast size={24} />
      </Button>

      <div className='my-4 px-10'>
        <div className='relative'>
          <div className='absolute inset-0 flex items-center'>
            <div className='w-full border-t border-gray-500' />
          </div>
          <div className='relative flex justify-center text-sm'>
            <span className='px-2 bg-white text-gray-500 text-xs'>OR</span>
          </div>
        </div>
      </div>

      <p className='font-medium text-center'>
        Back to <Link to={routes.login}>Signin</Link>
      </p>
    </form>
  );
};

export default ForgetPasswordForm;
